import Vue from 'vue'
import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Spinner,
  Card,
  Steps,
  Step,
  Collapse,
  CollapseItem,
  Cascader,
  Transfer,
  Timeline,
  TimelineItem,
  Divider,
  Backtop,
  CascaderPanel,
  Loading,
  MessageBox,
  Message,
  Notification,
  Scrollbar,
  Badge,
  Carousel,
  CarouselItem,
  Descriptions,
  DescriptionsItem,
  Result,
  Popconfirm
} from 'element-ui'

// 在 style 目录下的 element-ui.scss 已经手动引入饿了么的样式并覆盖，这里不需要再引入
// import 'element-ui/lib/theme-chalk/index.css'

import { i18n } from '@/i18n'

Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Autocomplete)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Spinner)
Vue.use(Card)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Cascader)
Vue.use(Transfer)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Divider)
Vue.use(Backtop)
Vue.use(CascaderPanel)
Vue.use(Scrollbar)
Vue.use(Badge)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Result)
Vue.use(Popconfirm)

Vue.use(Loading.directive)

Vue.prototype.$ELEMENT = { size: 'mini', i18n: (key, value) => i18n.t(key, value) }
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

// custom 处理

function reportErrorToSentry(error) {
  console.error(error)
  if (error instanceof Error) {
    Vue.captureException(error)
  } else if (!error.message.includes('您没有此权限')) {
    Vue.captureException(new Error(error.message || '未知错误'))
  }
}

// 增强默认的 element 消息处理
Vue.prototype.$alert = function(message, ...args) {
  let [title, options] = args
  if (!options) {
    options = title
  }
  if (options && options.error) {
    reportErrorToSentry(options.error)
  }
  return MessageBox.alert(message, ...args)
}
Vue.prototype.$message = function(options) {
  if (options.error) {
    reportErrorToSentry(options.error)
  }
  return Message({
    duration: 5000,
    ...options
  })
}
// 先重写 $message 再添加静态方法
Vue.prototype.$message.success = Message.success
Vue.prototype.$message.error = Message.error
Vue.prototype.$message.warning = Message.warning
Vue.prototype.$message.info = Message.info
Vue.prototype.$message.closeAll = Message.closeAll
Vue.prototype.MessageBox = MessageBox

// 添加 $alert 静态方法
;['success', 'warning', 'info', 'error'].forEach(type => {
  Vue.prototype.$alert[type] = function(message, ...args) {
    let [title, options] = args
    if (!title || typeof title === 'object') {
      options = title || {}
      title = undefined
    }
    if (typeof title === 'string' && !options) {
      options = {}
    }
    if (options && options.error) {
      reportErrorToSentry(options.error)
    }

    options.type = type
    return MessageBox.alert(message, title, options)
  }
})
